import { Badge } from "~/components/ui/badge";

export const EnvironmentBadge = () => {
	if (import.meta.env.VITE_ENVIRONMENT === "production") {
		return null;
	}

	return (
		<Badge
			color={
				import.meta.env.VITE_ENVIRONMENT === "production"
					? "red"
					: import.meta.env.VITE_ENVIRONMENT === "staging"
						? "yellow"
						: "green"
			}
		>
			{import.meta.env.VITE_ENVIRONMENT || "local"}
		</Badge>
	);
};
